import { create } from "zustand";

interface HomeGoalStoreState {
  targetAmount: number;
  selectedCities: string[];
  propertyTypes: string[];
  setTargetAmount: (amount: number) => void;
  setSelectedCities: (cities: string[]) => void;
  setPropertyTypes: (
    typesOrUpdater: string[] | ((prev: string[]) => string[])
  ) => void;
}

const useHomeGoalStore = create<HomeGoalStoreState>((set) => ({
  targetAmount: 0,
  selectedCities: [],
  propertyTypes: [],
  setTargetAmount: (amount: number) => set({ targetAmount: amount }),
  setSelectedCities: (cities: string[]) => set({ selectedCities: cities }),
  setPropertyTypes: (typesOrUpdater) =>
    set((state) => ({
      propertyTypes:
        typeof typesOrUpdater === "function"
          ? typesOrUpdater(state.propertyTypes)
          : typesOrUpdater,
    })),
}));

export { useHomeGoalStore };
